import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { CustomSelect } from '../../../UsersList/components/CustomSelect';
import { jobStatusOptions } from '../../shared/constants';
import { userDaSubProfessions } from '../../../../../constants';
import { MultiStatePicker } from '../../../../commonComponents/MultiStatePicker';
import debounceHook from '../../../../commonComponents/debounceHook';
import { useGetPaymentPlans } from '../../../../../domain/PermanentJobs/useCases/useGetPaymentPlans';
import { useGetUsersByIds } from '../../../../../domain/Users';
import { RemoteConfigUtils } from '../../../../../utils/RemoteConfigUtils';

export const Filters = ({ filters, handleFilterChanged }) => {
  const { data: paymentPlans } = useGetPaymentPlans();
  const { data: recruiters } = useGetUsersByIds(RemoteConfigUtils.getPermanentRecruiterIds());

  const [searchOfficeName, setSearchOfficeName] = useState(filters?.officeName || '');
  const debouncedSearchText = debounceHook(searchOfficeName, 1000);

  const allProfessions = useSelector((state) => state.jobs.allProfessions);

  useEffect(() => {
    handleFilterChanged('officeName', searchOfficeName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchText]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <p>Office Name:</p>
        <input
          style={{
            paddingLeft: '8px',
            fontFamily: 'Nunito-Regular',
            width: 250,
            height: 32,
          }}
          placeholder="Search by office name"
          value={searchOfficeName}
          onChange={(event) => setSearchOfficeName(event.target.value)}
        />
      </div>

      <CustomSelect
        key="plan"
        id="plan"
        label="Plan"
        options={[
          { code: '', name: 'All' },
          ...(paymentPlans || []).map((plan) => ({
            code: plan.id,
            name: plan.name,
          })),
        ]}
        value={filters?.plan || ''}
        onChange={handleFilterChanged}
      />

      <CustomSelect
        key="recruiter"
        id="recruiter"
        label="Recruiter"
        options={[
          { code: '', name: 'All' },
          ...(recruiters || []).map((recruiter) => ({
            code: recruiter.id,
            name: recruiter.email,
          })),
        ]}
        value={filters?.recruiter || ''}
        onChange={handleFilterChanged}
      />

      <CustomSelect
        key="profession"
        id="professionType"
        label="Profession"
        options={[
          { code: '', name: 'All' },
          ...(allProfessions || []),
          ...(userDaSubProfessions || []),
        ]}
        value={filters?.professionType || ''}
        onChange={handleFilterChanged}
      />

      <CustomSelect
        key="status"
        id="status"
        label="Status"
        options={[{ code: '', name: 'All' }, ...jobStatusOptions].map((status) => ({
          code: status.code,
          name: status.name,
        }))}
        value={filters?.status || ''}
        onChange={handleFilterChanged}
      />

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          minWidth: 150,
        }}
      >
        <p>State:</p>
        <MultiStatePicker
          style={{ width: '150px' }}
          optionsStyle={{ width: '150px' }}
          value={filters?.states}
          onChange={(value) => handleFilterChanged('states', value)}
        />
      </div>
    </div>
  );
};
